import { render, staticRenderFns } from "./TransferredToLive.container.vue?vue&type=template&id=995b5ed2&scoped=true&"
import script from "./TransferredToLive.container.vue?vue&type=script&lang=js&"
export * from "./TransferredToLive.container.vue?vue&type=script&lang=js&"
import style0 from "./TransferredToLive.container.vue?vue&type=style&index=0&id=995b5ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995b5ed2",
  null
  
)

export default component.exports